export default "__VITE_ASSET__17c7b42b__"